import { Box, Button, Container, Link, Stack } from '@mui/material'
import type { ComponentType } from 'preact'
import { useLocation } from 'preact-iso'
import { AccountMenu } from './auth/AccountMenu'
import { useSession } from './auth/session'

/**
 * Header of the pages outside events: the brand, the sections the user may open (their
 * events, and the administration for a superadmin), and the account menu.
 */
export function AppHeader() {
  const { me } = useSession()
  const { path } = useLocation()
  const sections = me?.superadmin
    ? [
        { href: '/', label: 'Mes événements' },
        { href: '/admin', label: 'Administration' },
      ]
    : []
  return (
    <Box
      component="header"
      sx={{
        bgcolor: 'background.paper',
        borderBottom: 1,
        borderColor: 'divider',
        displayPrint: 'none',
      }}
    >
      <Container maxWidth="md" sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 1.5 }}>
        <Link
          href="/"
          underline="none"
          color="text.primary"
          sx={{ fontWeight: 800, fontSize: 20, letterSpacing: '-0.02em' }}
        >
          Event
        </Link>
        <Stack component="nav" aria-label="Navigation" direction="row" sx={{ flex: 1, gap: 0.5 }}>
          {sections.map((section) => (
            <Button
              key={section.href}
              href={section.href}
              size="small"
              color={path === section.href ? 'primary' : 'inherit'}
              aria-current={path === section.href ? 'page' : undefined}
              sx={{ fontWeight: path === section.href ? 700 : 500 }}
            >
              {section.label}
            </Button>
          ))}
        </Stack>
        {me ? (
          <AccountMenu withName />
        ) : (
          me === null && (
            <Button href="/login" variant="outlined" size="small">
              Se connecter
            </Button>
          )
        )}
      </Container>
    </Box>
  )
}

/** A page outside events, under the app header. */
export function withHeader<P extends object>(Page: ComponentType<P>): ComponentType<P> {
  return (props: P) => (
    <>
      <AppHeader />
      <Page {...props} />
    </>
  )
}
